/**
 * @author lifei
 * 模块说明：销售价格管理
 */
import { Service } from '@/tools'
export class PriceServer<T extends TOrder.Price> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Price}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Price}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }

  /**
   * 功能：销售定价列表分页
   * /api/order/price/v1/pagePrice
   */
  pagePrice = <K extends T['ApiPagePrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPagePrice', data)

  /**
   * 功能：销售定价禁用
   * /api/order/price/v1/disablePrice
   */
  disablePrice = <K extends T['ApiDisablePrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDisablePrice', data, '禁用成功')

  /**
   * 功能：销售定价启用
   * /api/order/price/v1/enablePrice
   */
  enablePrice = <K extends T['ApiEnablePrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEnablePrice', data, '启用成功')

  /**
   * 功能：销售定价复制
   * /api/order/price/v1/copyPrice
   */
  copyPrice = <K extends T['ApiCopyPrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCopyPrice', data)

  /**
   * 功能：销售定价查看
   * /api/order/price/v1/queryPriceDetail
   */
  queryPriceDetail = <K extends T['ApiQueryPriceDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryPriceDetail', data)

  /**
   * 功能：销售定价新增-提交
   * /api/order/price/v1/insertPrice
   */
  insertPrice = <K extends T['ApiInsertPrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInsertPrice', data, '提交成功')
  /**
   * 功能：销售定价新增
   * /api/order/price/v1/savePrice-保存
   */
  savePrice = <K extends T['ApiSavePrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSavePrice', data, '保存成功')
  /**
   * 功能：销售定价编辑
   * /api/order/price/v1/insertPrice-保存
   */
  editPrice = <K extends T['ApiEditPrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEditPrice', data, '提交成功')

  /**
   * 功能：关闭销售定价
   * /api/order/price/v1/closePrice
   */
  closePrice = <K extends T['ApiClosePrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiClosePrice', data, '关闭成功')
  /**
   * 功能：销售定价明细列表分页
   * /api/order/price/v1/pagePriceDetail
   */
  pagePriceDetail = <K extends T['ApiPagePriceDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPagePriceDetail', data)

  /**
   * 查询销售定价对外接口
   * /api/order/price/v1/queryPrice
   */
  queryPrice = <K extends T['ApiQueryPrice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryPrice', data)

  /**
   * 销售定价历史版本
   * /api/order/price/v1/queryPriceVersionList
   */
  queryPriceVersionList = <K extends T['ApiQueryPriceVersionList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryPriceVersionList', data)
  /**
   * 销售定价历史版本详情
   * /api/order/price/v1/queryPriceVersionDetail
   */
  queryPriceVersionDetail = <K extends T['ApiQueryPriceVersionDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryPriceVersionDetail', data)
  /**
   * 功能：销售定价导入商品
   */
  priceCommodityImport = (data: T['ApiPriceCommodityImport']['req']): Promise<T['ApiPriceCommodityImport']['res']> =>
    this.postUpload('v1/ApiPriceCommodityImport', data)
  /**
   * 功能：销售定价下载导入模板
   */
  priceCommodityDownloadReport = (): Promise<T['ApiPriceCommodityDownloadReport']['res']> =>
    this.post2('v1/ApiPriceCommodityDownloadReport', undefined,'blob')
}
